<template>
  <v-container fluid>
    <validation-observer ref="observer" v-slot="{ invalid }">
      <parametros
        ref="parametrosREF"
        :title="title"
        :item="item"
      />
      <v-row>
        <v-col cols="12" md="6" />
        <v-col cols="12" md="6">
          <v-btn
            id="btn-save-analise-bp"
            color="green"
            min-width="100"
            style="float: right"
            class="mt-n5"
            @click="salvar()"
            :disabled="invalid"
            :loading="loading"
          >
            Salvar
          </v-btn>
        </v-col>
      </v-row>
    </validation-observer>
  </v-container>
</template>

<script>
import AnalisesBancoPrecosService from "@/services/AnalisesBancoPrecosService";
import tourMixins from '@/mixins/tourMixins';

export default {
  mixins: [tourMixins],

  components: {
    parametros: () => import("@/components/analisesBancoPrecos/Parametros.vue")
  },

  mounted() {
    if (this.$route.params.id) this.getAnaliseBP(this.$route.params.id);
    this.iniciarTourPagina();
  },

  data: () => ({
    item: {},
    loading: false,
    arrTour: [
      {
        element: '#titulo-analise-bp',
        intro: 'Aqui você poderá inserir um nome para sua Análise de Banco de Preços.',
        scrollTo: "tooltip",
        position: 'right'
      },
      {
        element: '#date-picker-data-base',
        intro: 'Aqui você poderá inserir a Data Base.',
        scrollTo: "tooltip",
        position: 'left'
      },
      {
        element: '#date-picker-data-nota-fiscal',
        intro: 'Aqui você poderá inserir o período da nota fiscal.',
        scrollTo: "tooltip",
        position: 'left'
      },
      {
        element: '#btn-save-analise-bp',
        intro: 'Após seleção dos critérios anteriores, clique aqui para salvar e executar sua Análise de Banco de Preços.',
        scrollTo: "tooltip",
        position: 'left'
      },
    ]
  }),

  methods: {
    getAnaliseBP(id) {
      AnalisesBancoPrecosService.getAnaliseBP(id).then(response => {
        this.item = response.data.data;
      })
      .catch(error => {
        console.error(error);
        this.$toast.error('Erro ao recuperar análise de banco de preço.', '',{position:'topRight'});
      });
    },

    salvar() {
      const data = this.$refs.parametrosREF.exportData();
      this.loading = true;

      AnalisesBancoPrecosService.salvar(data).then(() => {
        this.$toast.success('Análise de banco de preço salva com sucesso.', '',{position:'topRight'})
        this.$router.push({ name: 'Analises Banco Precos Historico' });
      })
      .catch(error => {
        console.error(error);
        this.$toast.error('Erro ao salvar análise de banco de preço.', '',{position:'topRight'});
      })
      .finally(() => this.loading = false);
    },

    iniciarTourPagina() {
      if (this.tourFuncCalled) return;
      this.iniciarTour(this.arrTour);
    }
  },
  
  computed: {
    title() {
      return this.$route.params.id ? `Editando Análise de BP` : 'Adicionar Nova Análise de BP';
    }
  }
}
</script>